import { createContext } from "react";

export interface DeveloperContextValue {
  userID: number;
  username: string;
  userEmail: string;
  sessionKey?: string;
  handleUserID: (id: number) => void;
  handleUsername: (name: string) => void;
  handleUserEmail: (email: string) => void;
  handleSessionKey: (sessionKey?: string) => void;
}

export const DeveloperContext = createContext<null | DeveloperContextValue>(
  null
);
